<template>
    <div id="profile-item">
        <div class="user" v-if="authStatus">
            <img src="/img/profile.svg" alt="">
            <span>{{email}}</span>
        </div>
        <a v-if="authStatus" class="btn login-btn" href="/auth/logout">Log out</a>
        <a v-else type="button" data-toggle="modal" data-target="#loginModal" class="btn login-btn">Log in</a>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'profile-dropdown-item',
    props: {
        authStatus: {
            type: Object,
            description: 'Auth status'
        },
        email: {
            type: String,
            description: 'User email',
        },
    },
};
</script>

<style scoped lang="scss">
    #profile-item {
        .user {
            display: flex;
            align-items: center;
            min-width: 365px;
            span {
                display: inline-block;
                font-weight: 500;
                margin-left: 5px;
            }
        }
        .btn {
            margin-top: 10px;
        }
    }
</style>

